import z from "zod";
import { Gender } from "@/openapi/generated";
import { phoneZodField } from "@/schemas/shared/phone-field-schema";

const studentSchema = z.object({
  firstName: z.string().min(1, { message: "First name is required" }),
  lastName: z.string().min(1, { message: "Last name is required" }),
  birthday: z.object({
    day: z.string().min(1, { message: "Day is required" }),
    month: z.string().min(1, { message: "Month is required" }),
    year: z.string().min(1, { message: "Year is required" }),
  }),
  gender: z
    .string()
    .refine(
      (val) =>
        val === Gender.Male || val === Gender.Female || val === Gender.Other,
      { message: "Gender is required" }
    ),
});

export const parentCreateFormSchema = z
  .object({
    email: z
      .string()
      .optional()
      .refine((val) => !val || /\S+@\S+\.\S+/.test(val), {
        message: "Please enter a valid email address",
      }),
    firstName: z.string().min(1, { message: "First name is required" }),
    lastName: z.string().min(1, { message: "Last name is required" }),
    cellPhone: phoneZodField,
    address: z.string().optional().nullable(),
    city: z.string().optional().nullable(),
    state: z.string().optional().nullable(),
    zip: z.string().optional().nullable(),
    country: z.string().optional().nullable(),
    role: z.enum(["selfenroll", "parent"]),
    locations: z.array(z.string()).optional(),
    students: z.array(studentSchema).optional(),
  })
  .refine(
    (data) => {
      if (data.role === "selfenroll") {
        return (
          (data.students?.length ?? 0) === 1 &&
          (data.locations?.length ?? 0) >= 1
        );
      }
      if (data.role === "parent" && (data.students?.length ?? 0) > 0) {
        return (data.locations?.length ?? 0) >= 1;
      }
      return true;
    },
    {
      message: "Please select at least one location when adding students",
      path: ["locations"],
    }
  );

export type ParentCreateFormSchemaType = z.infer<
  typeof parentCreateFormSchema
>;
